// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__M23xb","subpage":"Page_subpage__2rLFj"};